var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip",
          value: _vm.tooltipText,
          expression: "tooltipText"
        }
      ],
      ref: "wrap",
      class: _vm.styles
    },
    [
      _c(
        "div",
        { ref: "inner", staticClass: "club-calendar-points__inner" },
        [
          _c(
            "div",
            { staticClass: "club-calendar-points__title txt-overflow" },
            [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
          ),
          _c(
            "div",
            { staticClass: "club-calendar-points__points txt-overflow" },
            [
              _vm._v(
                "\n      " + _vm._s(_vm._f("price")(_vm.points)) + "\n    "
              )
            ]
          ),
          _c("vue-client-only", [
            _c(
              "div",
              { staticClass: "club-calendar-points__date txt-overflow" },
              [_vm._v("\n        " + _vm._s(_vm.promoPeriod) + "\n      ")]
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }